const collectionTitle = document.querySelector('.collection-hero__title')?.innerText || '';
const isDiningChairsPlp = document.querySelector('.sec-collection_dining-chairs') != null;
const isBarStoolsPlp = document.querySelector('.sec-collection_bar-stools') != null;
/** Combined cards: unit/"each" pricing + colour text (dining chairs + bar stools). */
const isDiningStyleCombinedPlp = isDiningChairsPlp || isBarStoolsPlp;

/**
 * GrapheneHC facet labels often expose raw metafield keys — rename for storefront UI.
 * Runs after category/search inject (graphenehcSuccessResponse).
 */
const PLP_FACET_LABEL_OVERRIDES = [
  { pattern: 'category_main', label: 'Category' },
  {
    pattern: 'custom[_.]?is[_.]?showroom|is\\s*showroom',
    label: 'View in our Showroom',
    preserveCase: true,
  },
];

const SHOWROOM_FACET_RE = /custom[_.]?is[_.]?showroom|is\s*showroom|view in our showroom/i;
const SHOWROOM_FACET_TITLE_CLASS = 'plp-FacetTitle-showroom';

function markShowroomFacetTitle(el) {
  if (!el) return;
  el.classList.add(SHOWROOM_FACET_TITLE_CLASS);
  el.closest('.mobile-facets__summary, .facets__summary, details')?.classList.add(
    SHOWROOM_FACET_TITLE_CLASS
  );
}

function rewriteTrueTextNodes(root) {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, noscript')) continue;
    if (parent.closest('summary, .facets__summary, .mobile-facets__summary')) continue;
    const text = node.textContent;
    if (!text || !/\btrue\b/i.test(text)) continue;
    node.textContent = text.replace(/\btrue\b/gi, 'On Display');
  }
}

function renameShowroomFacetValues(scope) {
  if (!scope?.querySelectorAll) return;

  const containers = new Set();

  scope
    .querySelectorAll(
      'details.js-filter, details.mobile-facets__details, details.facets__disclosure, details.facets__disclosure-vertical, details'
    )
    .forEach((details) => {
      const summary =
        details.querySelector(
          'summary, .facets__summary, .mobile-facets__summary, [data-title], span.title'
        ) || details;
      const haystack = `${summary.getAttribute?.('data-title') || ''} ${summary.textContent || ''}`;
      if (SHOWROOM_FACET_RE.test(haystack)) containers.add(details);
    });

  // Sibling header / value layouts (GrapheneHC): walk up from the title until True is in scope
  scope
    .querySelectorAll(
      '[data-title], .mobile-facets__summary, .facets__summary, .facets__summary-label, span.title'
    )
    .forEach((el) => {
      const haystack = `${el.getAttribute('data-title') || ''} ${el.textContent || ''}`;
      if (!SHOWROOM_FACET_RE.test(haystack)) return;

      let node = el.parentElement;
      for (let i = 0; i < 8 && node && node !== scope; i += 1) {
        if (/\btrue\b/i.test(node.textContent || '')) {
          containers.add(node);
          break;
        }
        node = node.parentElement;
      }
    });

  containers.forEach((container) => rewriteTrueTextNodes(container));

  scope.querySelectorAll('.active-facets__button-inner, .active-facets__button').forEach((el) => {
    if (!SHOWROOM_FACET_RE.test(el.textContent || '')) return;
    rewriteTrueTextNodes(el);
    if (/\btrue\b/i.test(el.textContent || '')) {
      el.textContent = el.textContent.replace(/\btrue\b/gi, 'On Display');
    }
  });
}

function renamePlpFacetLabels(root = document) {
  try {
    const overrides = Array.isArray(PLP_FACET_LABEL_OVERRIDES) ? PLP_FACET_LABEL_OVERRIDES : [];
    const scopes = [];
    if (root?.querySelectorAll) {
      const found = root.querySelectorAll(
        '.FacetsFilterWrapper, .mobile-facets, facet-filters-form, #FacetFiltersForm, .acs_collection_results, .acs_results'
      );
      if (found.length) scopes.push(...found);
    }
    if (!scopes.length) scopes.push(root || document);

    scopes.forEach((scope) => {
      if (!scope?.querySelectorAll) return;

      const nodes = scope.querySelectorAll(
        '[data-title], .mobile-facets__summary span:first-child, .facets__summary span:first-child, .facets__summary-label, span.title, .active-facets__button-inner'
      );

      nodes.forEach((el) => {
        overrides.forEach(({ pattern, label, preserveCase }) => {
          const re = new RegExp(pattern, 'gi');
          const title = el.dataset?.title || '';
          let matched = false;
          if (title && re.test(title)) {
            el.setAttribute('data-title', label);
            matched = true;
          }
          const text = el.textContent || '';
          const next = text.replace(new RegExp(pattern, 'gi'), label);
          if (next !== text) {
            el.textContent = next;
            matched = true;
          }
          // Facet CSS uses text-transform: capitalize — preserve intentional casing
          if (matched && preserveCase) {
            if (el.getAttribute('data-title') === label || SHOWROOM_FACET_RE.test(el.textContent || '')) {
              el.textContent = (el.textContent || '').replace(SHOWROOM_FACET_RE, label);
              if (el.hasAttribute('data-title')) el.setAttribute('data-title', label);
            }
            markShowroomFacetTitle(el);
          }
        });

        // Already-renamed titles still need the class after Graphene re-injects markup
        if (
          el.getAttribute('data-title') === 'View in our Showroom' ||
          /^\s*View in our Showroom\s*$/i.test(el.textContent || '')
        ) {
          el.textContent = (el.textContent || '').replace(/view in our showroom/gi, 'View in our Showroom');
          markShowroomFacetTitle(el);
        }
      });

      renameShowroomFacetValues(scope);
    });
  } catch (err) {
    console.warn('[renamePlpFacetLabels]', err);
  }
}

window.renamePlpFacetLabels = renamePlpFacetLabels;

// GrapheneHC often re-hydrates facet lists after the first success callback —
// re-apply showroom/True copy a few times so “On Display” sticks.
if (typeof document !== 'undefined' && !window.__danettiShowroomFacetRetry) {
  window.__danettiShowroomFacetRetry = true;
  [300, 1000, 2500].forEach((ms) => {
    setTimeout(() => {
      if (typeof renamePlpFacetLabels === 'function') renamePlpFacetLabels();
    }, ms);
  });
}

const fetchCollection = async (url, _this) => {
  try {
    const res = await fetch(url);
    const data = await res.json();
    const priceElement = _this.querySelector('.js-Product_Price');
    const sizeElements = _this.querySelectorAll('.js-Product_size');
    const sizeTextElements = _this.querySelectorAll('.js-size');
    const unitLabelElement = _this.querySelector('.js-unit-label');
    const coloursElement = _this.querySelector('.prd-Card_Colours');
    const badgeElement = _this.querySelector('.js-card__content');
    if((data.size === 0 || data.size === undefined)  && data.price_min_value === '£0'){
      _this.style.display = 'none';
      return;
    }

    if (isDiningStyleCombinedPlp) {
      // Dining chairs / bar stools Combined collections: no "from"; Set of 2 pair price or unit + "each"
      const displayPrice = data.is_set_of_2 && data.price_min_set_value
        ? data.price_min_set_value
        : data.price_min_value;
      if (priceElement && displayPrice) priceElement.innerHTML = displayPrice;
      if (unitLabelElement) {
        unitLabelElement.textContent = data.unit_label || (data.is_set_of_2 ? 'Set of 2' : 'each');
      }
    } else {
      const effPrice = data.effective_min_value || data.price_min_value;
      if (priceElement && effPrice) priceElement.innerHTML = effPrice;
      const sizeCount = Number(data.size) || 0;
      if (sizeElements.length && sizeCount) {
        sizeElements.forEach((el) => {
          el.innerHTML = sizeCount;
        });
      }
      if (sizeCount === 1 && sizeTextElements.length) {
        sizeTextElements.forEach((el) => {
          el.innerHTML = 'size';
        });
      }
      const sizeTriggers = _this.querySelectorAll('.card-sizeinfo--trigger');
      sizeTriggers.forEach((el) => {
        el.hidden = !sizeCount;
        // Modal + underline only when 2+ sizes; single size is plain text
        const isMultiSize = sizeCount >= 2;
        el.classList.toggle('card-sizeinfo--static', !isMultiSize);
        el.disabled = !isMultiSize;
        el.setAttribute('aria-disabled', String(!isMultiSize));
        if (isMultiSize) {
          el.setAttribute('aria-haspopup', 'dialog');
        } else {
          el.removeAttribute('aria-haspopup');
        }
      });
    }

    let dataHtml = `<ul class="prd-Colours_Items list-unstyled">`;
    if (data.colour) {
      const colours = data.colour.split('|').filter(c => c.trim() !== '');
      const maxSwatches = 5;
      colours.slice(0, maxSwatches).forEach(colour => {
        let border;
        if(colour == '#ffffff') border = 'border-color:#e5e5e5;';
        dataHtml += `<li class="prd-Colours_Item"><span class="prd-Colours_Button" style="--Swatch_Color: ${colour};${border}"></span></li>`;
      });
      // Dining-style Combined cards show "N colours" text — skip "+N" overflow chip (it caused uneven gaps)
      if (!isDiningStyleCombinedPlp && colours.length > maxSwatches) {
        dataHtml += `<li class="prd-Colours_Item prd-Colours_Item-total">+${colours.length - maxSwatches}</li>`;
      }
    }
    dataHtml += `</ul>`;
    if (data.colour) {
      const colours = data.colour.split('|').filter(c => c.trim() !== '');
      if(colours.length == 1){
        dataHtml += `<span class="prd-Colours_Item-total">${colours.length} colour</span>`;
      }else{
        dataHtml += `<span class="prd-Colours_Item-total">${colours.length} colours</span>`;
      }
    }
    if (coloursElement) coloursElement.innerHTML = dataHtml;
    if(data.discount_percentage) {
      badgeElement.querySelector('.badge').innerHTML = data.discount_percentage;
      badgeElement.style.display = 'flex';
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    _this.style.display = 'none';
  }
};

document.querySelectorAll('.clc-Hero_Items .clc-Hero_Item').forEach(el => {
  const subSectionText = el.querySelector('.clc-HeroCard_Link').innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP header links',subSectionText);
  }, false);
}); 
document.querySelectorAll('.sec-CollectionFAQs_Columns .sec-CollectionFAQs_PillListItem').forEach(el => {
  const subSectionText = el.innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP footer links',subSectionText);
  }, false);
}); 
document.querySelectorAll('.sec-collection-feature-blog .blog__post').forEach(el => {
  const subSectionText = el.querySelector('.card__heading a').innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP Blog carousel',subSectionText);
  }, false);
}); 
document.querySelectorAll('.collection-hero__description [data-el="un-truncate.triggerOpen"]').forEach((btn) => {
  const root = btn.closest('.collection-hero__description');
  if (!root) return;
  btn.addEventListener('click', () => {
    const collapsed = root.querySelector('.un-truncate-content');
    const expanded = root.querySelector('[data-el="un-truncate.fullContent"]');
    if (collapsed) collapsed.style.display = 'none';
    if (expanded) expanded.style.display = 'block';
  });
});
document.querySelectorAll('.collection-hero__description [data-el="un-truncate.triggerClose"]').forEach((btn) => {
  const root = btn.closest('.collection-hero__description');
  if (!root) return;
  btn.addEventListener('click', () => {
    const collapsed = root.querySelector('.un-truncate-content');
    const expanded = root.querySelector('[data-el="un-truncate.fullContent"]');
    if (collapsed) collapsed.style.display = 'block';
    if (expanded) expanded.style.display = 'none';
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const _thisCollection = document.querySelector('#product-promo-grid');
  if(_thisCollection){
    // Scope Combined card pricing to the parent PLP product type so bar stools
    // don't undercut dining chair Set of 2 prices (and vice versa on benches).
    const collectionHandle = _thisCollection.getAttribute('data-collection-handle');
    const typeFilterMap = {
      'dining-chairs': 'Dining Chairs',
      'dining-benches': 'Dining Benches',
      'bar-stools': 'Bar Stools'
    };
    const typeFilter = typeFilterMap[collectionHandle] || '';
    _thisCollection.querySelectorAll(".promotion-combined_collection").forEach(function (item) {
      const handle = item.getAttribute('data-handle');
      let url = `/collections/${handle}?view=json`;
      if (typeFilter) {
        url += `&filter.p.product_type=${encodeURIComponent(typeFilter)}`;
      }
      fetchCollection(url, item);
    });
  }
});

const PLP_EMPTY_IGNORE_PARAMS = new Set(['pg', 'page', 'sort', 'view', 'grid_list', 'pb']);

const hasActivePlpFilters = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    for (const key of params.keys()) {
      if (!PLP_EMPTY_IGNORE_PARAMS.has(key.toLowerCase())) return true;
    }
  } catch (_) {}

  if (document.querySelector('.active-facets__button-remove, .active-facets__button-wrapper .active-facets__button')) {
    return true;
  }

  const grid = document.querySelector('#product-grid');
  if (grid?.getAttribute('data-label') === 'true' || grid?.getAttribute('data-filter') === 'true') {
    return true;
  }

  return false;
};

const plpProductCollectionsCache = new Map();
const plpProductFeaturedImageCache = new Map();
let plpPromoCollectionsSyncToken = 0;

const getPlpProductHandleFromCard = (cardRoot) => {
  const link =
    cardRoot.querySelector('.card__heading a') ||
    cardRoot.querySelector('.prd-Card_TitleLink') ||
    cardRoot.querySelector('a[href*="/products/"]');
  const href = link?.getAttribute('href');
  if (!href) return null;
  const match = href.match(/\/products\/([^/?#]+)/);
  return match?.[1] || null;
};

const getFilteredPlpProductCards = () => {
  const grid = document.querySelector('#product-grid');
  if (!grid) return [];

  const cards = [];
  const seen = new Set();
  grid.querySelectorAll('.grid__item:not(.plp-empty-state):not(.promotion__item)').forEach((item) => {
    if (item.querySelector('.promotion-combined_collection')) return;
    const handle = getPlpProductHandleFromCard(item);
    if (!handle || seen.has(handle)) return;
    seen.add(handle);
    cards.push({ handle, item });
  });
  return cards;
};

const getFilteredPlpProductHandles = () => {
  return getFilteredPlpProductCards().map((card) => card.handle);
};

const getPlpCardPrimaryImage = (cardRoot) => {
  const media =
    cardRoot.querySelector('.card__media') ||
    cardRoot.querySelector('.prd-Card_ImageContainer') ||
    cardRoot.querySelector('.prd-Card_Image');
  if (!media) return null;

  const images = Array.from(media.querySelectorAll('img'));
  if (!images.length) return null;

  return (
    images.find((img) => {
      return (
        !img.closest('.prd-Card_Image-hover') &&
        !img.classList.contains('hover') &&
        !img.classList.contains('motion-reduce--hover')
      );
    }) || images[0]
  );
};

const isPlpPlaceholderImageSrc = (src) => {
  return !src || src.startsWith('data:') || src.includes('placeholder');
};

const getPlpCardPrimaryImageSource = (cardRoot) => {
  const img = getPlpCardPrimaryImage(cardRoot);
  if (!img) return null;

  const rawSrc = img.getAttribute('src') || '';
  const src = !isPlpPlaceholderImageSrc(rawSrc)
    ? rawSrc
    : img.getAttribute('data-src') || img.currentSrc || '';
  const srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
  if (isPlpPlaceholderImageSrc(src) && !srcset) return null;

  return { src, srcset };
};

const getPromoCollectionImage = (item) => {
  return item.querySelector('.clc-Promotion_Image img, .card__media img');
};

const cachePromoCollectionOriginalImage = (item) => {
  const img = getPromoCollectionImage(item);
  if (!img || img.hasAttribute('data-plp-original-src')) return;

  img.setAttribute('data-plp-original-src', img.getAttribute('src') || '');
  img.setAttribute('data-plp-original-srcset', img.getAttribute('srcset') || '');
};

const applyPromoCollectionMatchedImage = (item, source) => {
  const img = getPromoCollectionImage(item);
  if (!img || !source) return;

  cachePromoCollectionOriginalImage(item);
  if (source.src) img.setAttribute('src', source.src);
  if (source.srcset) {
    img.setAttribute('srcset', source.srcset);
  } else {
    img.removeAttribute('srcset');
  }
};

const restorePromoCollectionOriginalImage = (item) => {
  const img = getPromoCollectionImage(item);
  if (!img?.hasAttribute('data-plp-original-src')) return;

  img.setAttribute('src', img.getAttribute('data-plp-original-src') || '');
  const originalSrcset = img.getAttribute('data-plp-original-srcset');
  if (originalSrcset) {
    img.setAttribute('srcset', originalSrcset);
  } else {
    img.removeAttribute('srcset');
  }
};

const fetchPlpProductCollections = async (handle) => {
  if (plpProductCollectionsCache.has(handle)) {
    return plpProductCollectionsCache.get(handle);
  }

  const promise = (async () => {
    try {
      const fetchFn =
        typeof fetchProductMetafieldData === 'function'
          ? fetchProductMetafieldData
          : typeof fetchJSON === 'function'
            ? (h) => fetchJSON(`/products/${h}?view=json`)
            : (h) => fetch(`/products/${h}?view=json`).then((r) => r.json());
      const data = await fetchFn(handle);
      if (data?.featured_image) {
        plpProductFeaturedImageCache.set(handle, data.featured_image);
      }
      return Array.isArray(data?.collections) ? data.collections.filter(Boolean) : [];
    } catch (_) {
      return [];
    }
  })();

  plpProductCollectionsCache.set(handle, promise);
  return promise;
};

const ensurePromoCountBaseline = (promoSection) => {
  if (!promoSection) return 0;
  if (!promoSection.hasAttribute('data-count-all')) {
    const baseline =
      promoSection.getAttribute('data-count') ||
      String(promoSection.querySelectorAll('.promotion-combined_collection').length);
    promoSection.setAttribute('data-count-all', baseline);
  }
  return parseInt(promoSection.getAttribute('data-count-all'), 10) || 0;
};

const updatePromoCollectionsCount = (promoSection, count) => {
  if (!promoSection) return;
  const nextCount = String(Math.max(0, count));
  promoSection.setAttribute('data-count', nextCount);
  document.querySelectorAll('.plp-collections_btn .js-count').forEach((el) => {
    el.innerHTML = nextCount;
  });
};

const restoreAllPromoCollections = () => {
  const promoSection = document.querySelector('.sec-collection_promo');
  const promoGrid = document.querySelector('#product-promo-grid');
  if (!promoSection || !promoGrid) return;

  const baseline = ensurePromoCountBaseline(promoSection);
  promoGrid.querySelectorAll('.promotion-combined_collection').forEach((item) => {
    item.classList.remove('is-plp-filter-hidden');
    restorePromoCollectionOriginalImage(item);
  });
  updatePromoCollectionsCount(promoSection, baseline);
};

/**
 * When PLP filters are active, show only Combined collections that contain
 * at least one currently rendered filtered product. Restores full list when filters clear.
 * Matched collection cards use the first filtered product image (grid order) for that collection.
 */
const syncPromoCollectionsFromFilteredProducts = async () => {
  const promoSection = document.querySelector('.sec-collection_promo');
  const promoGrid = document.querySelector('#product-promo-grid');
  if (!promoSection || !promoGrid) return;

  ensurePromoCountBaseline(promoSection);
  const syncToken = ++plpPromoCollectionsSyncToken;

  if (!hasActivePlpFilters()) {
    restoreAllPromoCollections();
    return;
  }

  const productCards = getFilteredPlpProductCards();
  if (!productCards.length) {
    promoGrid.querySelectorAll('.promotion-combined_collection').forEach((item) => {
      item.classList.add('is-plp-filter-hidden');
      restorePromoCollectionOriginalImage(item);
    });
    updatePromoCollectionsCount(promoSection, 0);
    return;
  }

  const collectionSets = await Promise.all(
    productCards.map((card) => fetchPlpProductCollections(card.handle))
  );
  if (syncToken !== plpPromoCollectionsSyncToken) return;

  const matchedHandles = new Set();
  const firstMatchedImageByCollection = new Map();
  collectionSets.forEach((handles, index) => {
    const source =
      getPlpCardPrimaryImageSource(productCards[index].item) ||
      (plpProductFeaturedImageCache.has(productCards[index].handle)
        ? { src: plpProductFeaturedImageCache.get(productCards[index].handle), srcset: '' }
        : null);
    handles.forEach((handle) => {
      matchedHandles.add(handle);
      if (source && !firstMatchedImageByCollection.has(handle)) {
        firstMatchedImageByCollection.set(handle, source);
      }
    });
  });

  let visibleCount = 0;
  promoGrid.querySelectorAll('.promotion-combined_collection').forEach((item) => {
    const handle = item.getAttribute('data-handle');
    const matches = handle && matchedHandles.has(handle);
    item.classList.toggle('is-plp-filter-hidden', !matches);
    if (matches) {
      visibleCount += 1;
      applyPromoCollectionMatchedImage(item, firstMatchedImageByCollection.get(handle));
    } else {
      restorePromoCollectionOriginalImage(item);
    }
  });

  updatePromoCollectionsCount(promoSection, visibleCount);
};

window.syncPromoCollectionsFromFilteredProducts = syncPromoCollectionsFromFilteredProducts;
window.restoreAllPromoCollections = restoreAllPromoCollections;

const syncPlpEmptyState = () => {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  const productItems = grid.querySelectorAll(
    '.grid__item:not(.plp-empty-state), .prd-Card, [data-product-handle]'
  ).length;
  const existing = grid.querySelector('.plp-empty-state');

  if (productItems > 0) {
    if (existing) existing.remove();
    grid.classList.remove('product-grid--empty');
    return;
  }

  const template = document.getElementById('plp-empty-state-template');
  if (!template) return;

  const hasFilters = hasActivePlpFilters();
  let emptyState = existing;

  if (!emptyState) {
    emptyState = template.content.firstElementChild.cloneNode(true);
    grid.appendChild(emptyState);
  }

  const filtersHint = emptyState.querySelector('[data-plp-empty-filters]');
  const browseCta = emptyState.querySelector('[data-plp-empty-browse]');

  if (filtersHint) filtersHint.hidden = !hasFilters;
  if (browseCta) browseCta.hidden = hasFilters;

  grid.classList.add('product-grid--empty');
};

document.addEventListener('swym:collections-loaded', () => {
  syncPlpEmptyState();
});

class StickyFilters extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;
    this.filterBounds = {};
    this.onScrollHandler = this.onScroll.bind(this);
    this.filter = document.querySelector('.acs_collection_results');
    this.hero = document.querySelector('.collection-hero');
    this.hideFilterOnScrollUp = () => (this.preventReveal = true);
    this.createObserver();
  }

  connectedCallback() {
    this.addEventListener('preventHeaderReveal', this.hideFilterOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideFilterOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];   
      const target = entry.target;
      this.filterBounds = entry.boundingClientRect;
      observer.unobserve(target);
    });
    observer.observe(this.filter);
  }

  onScroll() {
    if (document.documentElement.dataset.facetDrawerScrollLocked === 'true') return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 0;
    const heroBottom = this.hero
      ? (this.hero.getBoundingClientRect().top + window.pageYOffset + this.hero.offsetHeight - headerHeight)
      : 0;
    const stopSticky = this.filterBounds.top - (headerHeight + 20);
    const bottomSticky = stopSticky + (this.offsetHeight);
    const atTop = scrollTop <= (headerHeight + 5);
    const heroVisible = this.hero ? scrollTop < heroBottom : false;
    if (this.currentScrollTop === scrollTop) return;
    if (atTop || heroVisible) {
      this.resetFilter();
    } else if (scrollTop > this.currentScrollTop && scrollTop > bottomSticky) {
      this.hideFilter();
    } else if (scrollTop < this.currentScrollTop && scrollTop > bottomSticky) {
      this.revealFilter();
    } else if (scrollTop <= stopSticky) {
      this.resetFilter();
    }

    this.currentScrollTop = scrollTop;
  }

  hideFilter() {
    if (this.preventReveal) return;
    requestAnimationFrame(() => {
      this.filter.classList.add('filters-hidden', 'filters-sticky');
    });
  }

  revealFilter() {
    if (this.preventReveal) return;
    requestAnimationFrame(() => {
      this.filter.classList.remove('filters-hidden');
      this.filter.classList.add('filters-sticky', 'animate');
    });
    this.debouncePreventReveal();
  }

  resetFilter() {
    requestAnimationFrame(() => {
      this.filter.classList.remove('filters-hidden', 'filters-sticky', 'animate');
    });
  }

  debouncePreventReveal() {
    window.clearTimeout(this.isScrolling);
    this.isScrolling = setTimeout(() => {
      this.preventReveal = false;
    }, 66);
  }
}

window.StickyFilters = StickyFilters;
